import { create } from "zustand";

import type { DmAdsRegion } from "../services/dataManagement/region";

export interface OpenDocument {
  projectId: string;
  itemId: string;
  fileName: string;
  hubRegion?: DmAdsRegion;
}

interface DocumentViewerState {
  openDoc: OpenDocument | null;
  blobUrl: string | null;
  status: "idle" | "loading" | "ready" | "error";
  error: string | null;

  openDocument: (doc: OpenDocument) => void;
  setLoading: () => void;
  setReady: (blobUrl: string) => void;
  setError: (message: string) => void;
  close: () => void;
}

export const useDocumentViewerStore = create<DocumentViewerState>(
  (set, get) => ({
    openDoc: null,
    blobUrl: null,
    status: "idle",
    error: null,

    openDocument: doc => {
      const prev = get().blobUrl;
      if (prev) URL.revokeObjectURL(prev);
      set({ openDoc: doc, blobUrl: null, status: "loading", error: null });
    },

    setLoading: () => set({ status: "loading", error: null }),

    setReady: blobUrl => set({ blobUrl, status: "ready", error: null }),

    setError: message => set({ status: "error", error: message }),

    close: () => {
      const prev = get().blobUrl;
      if (prev) URL.revokeObjectURL(prev);
      set({ openDoc: null, blobUrl: null, status: "idle", error: null });
    },
  })
);
